import { ReactNode } from 'react'
import { Modal, Button } from 'react-bootstrap'

interface ModalConfirmProps {
  isOpen: boolean
  toggle: () => void
  action: () => void
  body?: string | ReactNode
  title?: string
  cancelText?: string
  confirmText?: string | ReactNode
  confirmVariant?: "secondary" | "primary" | "danger" | "success"
}

export default function ModalConfirm({
  isOpen,
  toggle,
  action,
  body = 'Sei sicuro di voler continuare?',
  title = 'Conferma azione',
  cancelText = 'Annulla',
  confirmText = 'OK',
  confirmVariant = 'secondary'
}: ModalConfirmProps) {
  return (
    <Modal
      show={isOpen}
      onHide={toggle}
      centered
      backdropClassName="backdrop-high"
    >
      <Modal.Header className="">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-2">{body}</div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button type="button" onClick={toggle} variant="outline-secondary">
          {cancelText}
        </Button>
        <Button
          type="button"
          onClick={action}
          variant={confirmVariant}
          className="text-white"
        >
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
